import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import {
  getDutyTariffLibAsync,
  getDutyTariffCountriesAsync,
  getDutyTariffDestinationCountriesAsync,
} from 'src/redux/async/libraries/dutytariffasync'

const initialState = {
  dutyTariffLibLoader: false,
  dutyTariffLibError: '',
  dutyTariffLibState: [],

  dutyTariffCountriesLoader: false,
  dutyTariffCountriesError: '',
  dutyTariffCountries: [],

  dutyTariffDestinationCountriesLoader: false,
  dutyTariffDestinationCountriesError: '',
  dutyTariffDestinationCountries: [],
  filters: {
    query: '',
    level_1: '',
    level_2: '',
    level_3: '',
    origin_country: [],
    destination_country: '',
  },
}

export const dutytariffLibrariesSlice = createSlice({
  name: 'dutytariffLibrariesData',
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(getDutyTariffLibAsync.pending), (state) => {
      state.dutyTariffLibLoader = true
    })
    builder.addMatcher(isAnyOf(getDutyTariffLibAsync.fulfilled), (state, action) => {
      state.dutyTariffLibLoader = false
      state.dutyTariffLibState = action.payload
      state.dutyTariffLibError = ''
    })
    builder.addMatcher(isAnyOf(getDutyTariffLibAsync.rejected), (state, action) => {
      state.dutyTariffLibLoader = false
      state.dutyTariffLibError = action.payload
    })

    builder.addMatcher(isAnyOf(getDutyTariffCountriesAsync.pending), (state) => {
      state.dutyTariffCountriesLoader = true
    })
    builder.addMatcher(isAnyOf(getDutyTariffCountriesAsync.fulfilled), (state, action) => {
      state.dutyTariffCountriesLoader = false
      state.dutyTariffCountries = action.payload.data
      state.dutyTariffCountriesError = ''
    })
    builder.addMatcher(isAnyOf(getDutyTariffCountriesAsync.rejected), (state, action) => {
      state.dutyTariffCountriesLoader = false
      state.dutyTariffCountriesError = action.payload
    })

    builder.addMatcher(isAnyOf(getDutyTariffDestinationCountriesAsync.pending), (state) => {
      state.dutyTariffDestinationCountriesLoader = true
    })
    builder.addMatcher(
      isAnyOf(getDutyTariffDestinationCountriesAsync.fulfilled),
      (state, action) => {
        state.dutyTariffDestinationCountriesLoader = false
        state.dutyTariffDestinationCountries = action.payload
        state.dutyTariffDestinationCountriesError = ''
      },
    )
    builder.addMatcher(
      isAnyOf(getDutyTariffDestinationCountriesAsync.rejected),
      (state, action) => {
        state.dutyTariffDestinationCountriesLoader = false
        state.dutyTariffDestinationCountriesError = action.payload
      },
    )
  },
  reducers: {
    setFilters: (state, action) => {
      state.filters = {
        ...state.filters,
        ...action.payload,
      }
    },
    clearFilters: (state, action) => {
      state.filters = structuredClone({ ...initialState.filters, ...action.payload })
    },
  },
})

export const { setFilters, clearFilters } = dutytariffLibrariesSlice.actions

export default dutytariffLibrariesSlice.reducer
